module.exports = __webpack_public_path__ + "static/img/594x100_2.e8ed31f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/594x100_2.png
// module id = WzjM
// module chunks = 8